module.exports = __webpack_public_path__ + "static/media/UniNeueLight-Italic.3f55e26f.woff";